import { commonAPI } from '@redux/api'

import { URLS } from '@constants'
import {
  GETSearchParams,
  GETSearchType,
  POSTCreateSearchType,
  POSTDefaultSearchType,
  POSTSearchTitleType,
} from '@types'

export const searchApi = commonAPI.injectEndpoints({
  endpoints: build => ({
    createSearchFilter: build.mutation<void, POSTCreateSearchType>({
      query: search => ({
        url: URLS.FRONT_CFG + '/search',
        method: 'POST',
        body: { ...search, overwriting: false },
      }),
      invalidatesTags: ['Search'],
    }),
    updateSearchFilter: build.mutation<GETSearchType, POSTCreateSearchType>({
      query: body => ({
        url: URLS.FRONT_CFG + '/search',
        method: 'POST',
        body: { ...body, overwriting: true },
      }),
      invalidatesTags: ['Search'],
    }),
    updateSearchFilterTitle: build.mutation<GETSearchType, POSTSearchTitleType>({
      query: body => ({
        url: URLS.FRONT_CFG + '/search/title',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Search'],
    }),
    updateDefaultSearchFilter: build.mutation<GETSearchType, POSTDefaultSearchType>({
      query: body => ({
        url: URLS.FRONT_CFG + `/search/default`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Search'],
    }),
    fetchSearchFilters: build.query<GETSearchType[], GETSearchParams>({
      query: ({ objectCode, searchAssistantId }) => ({
        url:
          URLS.FRONT_CFG +
          `/search/objectCode/${objectCode}/searchAssistant/id/${searchAssistantId}`,
      }),
      providesTags: ['Search'],
      serializeQueryArgs: ({ endpointName, queryArgs }) => {
        return `${endpointName}:${queryArgs.objectCode}:${queryArgs.searchAssistantId}:${queryArgs.instanceId}`
      },
    }),
    deleteSearchFilter: build.mutation<void, number>({
      query: id => ({
        url: URLS.FRONT_CFG + `/search/id/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Search'],
    }),
  }),
})

export const {
  useFetchSearchFiltersQuery,
  useCreateSearchFilterMutation,
  useUpdateSearchFilterMutation,
  useUpdateSearchFilterTitleMutation,
  useUpdateDefaultSearchFilterMutation,
  useDeleteSearchFilterMutation,
} = searchApi
